import { ref, onScopeDispose, getCurrentScope } from 'vue';

// Aceleres: singleton reativo com "agora" em segundos (epoch/1000, mesma
// unidade que `message.createdAt` no Chatwoot). Serve como clock pra decisoes
// derivadas do tempo (ex.: colapso retroativo de albuns de imagens tipo
// WhatsApp em MessageList.vue). Compartilhado entre consumidores pra evitar
// N timers, e refcount decrementa a cada scope destruido — quando ninguem
// mais consome, o interval eh desligado.

const TICK_MS = 2000;

let now = null;
let refCount = 0;
let intervalId = null;

const start = () => {
  if (intervalId !== null) return;
  intervalId = setInterval(() => {
    now.value = Math.floor(Date.now() / 1000);
  }, TICK_MS);
};

const stop = () => {
  if (intervalId === null) return;
  clearInterval(intervalId);
  intervalId = null;
};

export function useReactiveNow() {
  if (now === null) {
    now = ref(Math.floor(Date.now() / 1000));
  }

  refCount += 1;
  start();

  if (getCurrentScope()) {
    onScopeDispose(() => {
      refCount -= 1;
      if (refCount <= 0) {
        refCount = 0;
        stop();
      }
    });
  }

  return now;
}
